module.exports = __webpack_public_path__ + "static/img/yay.bfe506b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/yay.jpeg
// module id = 3NJd
// module chunks = 35